interface VerticalBounds {
  top: number
  bottom: number
}

/** Reveal the bottom when the section fits; otherwise keep its first fields in view. */
export function accountSectionScrollDelta(section: VerticalBounds, viewport: VerticalBounds): number {
  const availableHeight = viewport.bottom - viewport.top
  if (availableHeight <= 0
      || (section.top >= viewport.top && section.bottom <= viewport.bottom))
    return 0

  return section.bottom - section.top <= availableHeight
    ? section.bottom - viewport.bottom
    : section.top - viewport.top
}
